class BaseApp {
    get external() {
        if (!window.BaseApp) {
            throw new Error('Не найден объект настроек BaseApp');
        }

        return window.BaseApp || {};
    }

    get initData() {
        return this.external.initData || {};
    }

    get url() {
        return this.external.url || {};
    }

    get images() {
        return this.initData.images || {};
    }

    get pushData() {
        return this.initData.push || {};
    }

    get staticUrl() {
        return this.url.static;
    }

    get workerUrl() {
        return this.url.worker;
    }

    get notificationsSoundSrc() {
        return this.initData.notificationSound;
    }

    get notificationsReconnect() {
        return '/notifications/connect';
    }

    get authUrl() {
        if (!this.initData.authUrl) {
            throw new Error('Auth url not setuped');
        }

        return this.initData.authUrl;
    }

    get cookie() {
        return this.external.cookie || {};
    }
}

export default new BaseApp();
